import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Electronic operators")
], -1)
const _hoisted_4 = { class: "col-auto" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Edit operator")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Delete")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_q_btn, {
          label: "Add new electronic operator",
          color: "primary",
          to: { name: _ctx.ElectronicOperatorsRouteNames.NEW, query: { page: _ctx.route.query.page } },
          unelevated: "",
          "no-caps": ""
        }, null, 8, ["to"])
      ])
    ]),
    _createVNode(_component_q_table, {
      columns: _ctx.electronicOperatorsColumns,
      rows: _ctx.electronicOperators,
      "row-key": "id",
      pagination: _ctx.pagination,
      "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event)),
      flat: "",
      "visible-columns": _ctx.visibleColumns
    }, {
      "body-cell-actions": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_q_btn, {
              dense: "",
              round: "",
              flat: "",
              color: "grey",
              onClick: ($event: any) => (_ctx.onEditElectronicOperatorRow(null, props.row)),
              icon: "edit"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_q_btn, {
              dense: "",
              round: "",
              flat: "",
              color: "grey",
              onClick: ($event: any) => (_ctx.onDeleteElectronicOperatorRow(props.row)),
              icon: "delete"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      _: 1
    }, 8, ["columns", "rows", "pagination", "visible-columns"])
  ]))
}